import { useFlippers } from "@shared/context/FlippersContext";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";

interface StickyProductResultsHeaderBreakpoints {
  isDrawer: boolean;
  isPatient: boolean;
  bannersHeight?: number;
}

const useStickyProductResultsHeaderBreakpoints = ({
  isDrawer,
  isPatient,
}: StickyProductResultsHeaderBreakpoints) => {
  const [isPillPacksEnabled] = useFlippers("cura_daily_packs_phase_2");
  const { phoneSmall, phoneLarge, tablet } = useBreakpoints();
  const isTinyPhone = phoneSmall.active && !phoneSmall.greaterThan;
  const isSmallPhone = phoneLarge.lessThan;
  const isLargePhone = !isSmallPhone && phoneLarge.active;
  const isTablet = !isLargePhone && tablet.active;

  if (isDrawer) {
    if (isPillPacksEnabled) {
      if (isTinyPhone) {
        return 442;
      }
      if (isSmallPhone) {
        return 388;
      }
      if (isLargePhone) {
        return 378;
      }
      if (isTablet) {
        return 470;
      }

      return 490;
    }

    return isSmallPhone ? 168 : 238;
  }

  if (isPatient) {
    if (isSmallPhone) {
      return 128;
    }
    if (isLargePhone) {
      return 160;
    }
    if (isTablet) {
      return 246;
    }

    return 220;
  }

  if (isSmallPhone) {
    return 124;
  }
  if (isLargePhone) {
    return 138;
  }

  return 162;
};
export { useStickyProductResultsHeaderBreakpoints };
